import { Link } from 'react-router-dom';
import { GameController } from '@phosphor-icons/react';
import { SITE } from '@/content/site';
import { openCookieSettings } from '../CookieConsent';

const columns = [
  {
    title: 'Play',
    links: [
      { to: '/auth', label: 'Launch App' },
      { to: '/guides', label: 'Game Guides' },
      { to: '/faq', label: 'FAQ' },
    ],
  },
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About Us' },
      { to: '/contact', label: 'Contact' },
      { to: '/community-guidelines', label: 'Community Guidelines' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/cookies', label: 'Cookie Policy' },
    ],
  },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const Footer = () => (
  <footer className="py-16 px-6 bg-[#09090B]" data-testid="site-footer">
    <div className="max-w-6xl mx-auto grid gap-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
      <div>
        <Link to="/" className="flex items-center gap-3 mb-4">
          <span className="bg-[#0047FF] p-2"><GameController size={22} weight="fill" color="#FFFFFF" /></span>
          <span className="font-heading text-lg font-bold text-white">DashLink Gaming</span>
        </Link>
        <p className="text-white/50 text-sm leading-relaxed max-w-xs">
          A free social gaming hub to play, chat and squad up with gamers worldwide.
        </p>
        <a href={`mailto:${SITE.email}`} className="mt-4 inline-block text-sm text-white/70 hover:text-white" data-testid="footer-email-link">
          {SITE.email}
        </a>
      </div>
      {columns.map((col) => (
        <div key={col.title}>
          <p className="text-xs font-mono uppercase tracking-widest text-white/40 mb-4">{col.title}</p>
          <ul className="space-y-3">
            {col.links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/70 hover:text-white transition-colors" data-testid={`footer-link-${slug(l.label)}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            {col.title === 'Legal' && (
              <li>
                <button type="button" onClick={openCookieSettings} className="text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-cookie-settings">
                  Cookie settings
                </button>
              </li>
            )}
          </ul>
        </div>
      ))}
    </div>
    <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-white/10 text-xs text-white/40 flex flex-col md:flex-row justify-between gap-2">
      <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.operator}. All rights reserved.</p>
      <p>Game titles and artwork are trademarks of their respective owners.</p>
    </div>
  </footer>
);
